module.exports = __webpack_public_path__ + "img/search.dea89882.svg";